import { useState, useEffect } from 'react'
import FeatureGatingManager from '~/managers/FeatureGatingManager'
import store from '~/biz/store/store'
import { ConfigManager, COUNTRY } from '~/managers/ConfigManager'

const useFeatureGate = () => {
  const [isWithdrawDisabled, setIsWithdrawDisabled] = useState(false)
  const [isDisbursementsDisabled, setIsDisbursementsDisabled] = useState(false)
  const [isCreditCardsEnabled, setIsCreditCardsEnabled] = useState(false)

  useEffect(() => {
    checkFeatureGate()
    async function checkFeatureGate() {
      setIsWithdrawDisabled(await disableWithdrawForSpecificBiz())
      setIsDisbursementsDisabled(await disableDisbursementsForSpecificBiz())
      setIsCreditCardsEnabled(await enableCreditCardsFeature())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    isWithdrawDisabled,
    isDisbursementsDisabled,
    isCreditCardsEnabled,
  }
}

async function disableWithdrawForSpecificBiz() {
  const { email, merchantId } = store.getState().route.user
  const isXfRegionalDisabled = await FeatureGatingManager.isEnabled(
    'xfregional_disable_withdraw',
    email
  )
  const isXfPayDisabled = await FeatureGatingManager.isEnabled('xfpay_disable_withdraw', merchantId)
  return (
    (ConfigManager.getCountry() === COUNTRY.INDONESIA && isXfPayDisabled) ||
    (ConfigManager.isRegionalSite() && isXfRegionalDisabled)
  )
}

async function disableDisbursementsForSpecificBiz() {
  const { merchantId } = store.getState().route.user
  const isXfPayDisbursementsDisabled = await FeatureGatingManager.isEnabled(
    'xfpay_disable_disbursements',
    merchantId
  )

  return ConfigManager.getCountry() === COUNTRY.INDONESIA && isXfPayDisbursementsDisabled
}

async function enableCreditCardsFeature() {
  const isCreditCardEnabled = await FeatureGatingManager.isEnabled(
    'xfregional_show_credit_cards',
    window.location.hostname
  )

  return isCreditCardEnabled && ConfigManager.isRegionalSite()
}

export default useFeatureGate
